import cx from 'classnames'

import { LIST_SIZE } from '@/blocks/constants'
import type { Space } from '@/components/Container'
import type { Midia } from '@/components/Media'
import { MediaTextBox } from '@/components/Media/MediaTextBox'
import type { ContentProps } from '@/components/Media/MediaTextBox/MediaTextBox'
import { HeadingL, Display, HeadingS } from '@/components/Typography'
import type { TitleProps } from '@/models'

import { MediaTestimonialStyles, MediaTestimonialHeader, MediaTestimonialBody } from './styles'

const MEDIA_WIDTH = '352px'
const MEDIA_HEIGHT = '264px'

export interface MediaTestimonialProps {
  title: TitleProps
  subtitle: TitleProps
  content: ContentProps
  space: Space
  size: 'm' | 'l'
  midia: Midia
}

const MediaTestimonialBlock = ({
  size,
  title,
  subtitle,
  space,
  ...mediaProps
}: MediaTestimonialProps) => {
  const mediaTextBoxProps = {
    ...mediaProps,
    width: MEDIA_WIDTH,
    height: MEDIA_HEIGHT,
  }

  const hasTextBoxContent = !!mediaProps.content?.title || !!mediaProps.content?.subtitle
  const hasMedia =
    (mediaTextBoxProps.midia.type === 'video' && !!mediaTextBoxProps.midia.video?.url) ||
    (mediaTextBoxProps.midia.type === 'image' && !!mediaTextBoxProps.midia.image?.url)

  const Heading = size === LIST_SIZE.lg ? Display : HeadingL

  return (
    <MediaTestimonialStyles className={cx('ecs-container', `eu-sm-${space}`, `eu-sp-${size}`)}>
      {(title || subtitle) && (
        <MediaTestimonialHeader>
          {title && title.text && <Heading tag={title.tag || 'h2'}>{title.text}</Heading>}

          {subtitle && subtitle.text && (
            <HeadingS
              className="media-testimonial__subheading eu-smt-2"
              tag={subtitle.tag || 'p'}
              dark="low"
            >
              {subtitle.text}
            </HeadingS>
          )}
        </MediaTestimonialHeader>
      )}

      {(hasTextBoxContent || hasMedia) && (
        <MediaTestimonialBody>
          <MediaTextBox {...mediaTextBoxProps} />
        </MediaTestimonialBody>
      )}
    </MediaTestimonialStyles>
  )
}

export default MediaTestimonialBlock
